module.exports = __webpack_public_path__ + "img/icon-jypx.3922eb06.png";